import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './MediaModule.scss';
import { useScreenSize } from '../../../helpers';

const MediaModule = ({ data = {}, stories = null }) => {
  const { isMobileScreen } = useScreenSize();
  const { logicalName, media = [] } = data;

  if (media.length === 0) return null;

  const storyStyles = useMemo(() => {
    if (stories === 'desktop') {
      return "story-desktop"
    } else if(stories === 'mobile'){
      return "story-mobile"
    }
    return 'full-screen-image';
  }, [stories]);

  return (
     <div id={logicalName}>
      {media.map((media, index) => (
      <img
      key={index}
      src={media.src}
      alt={media.ariaHidden ? '' : media.altText}
      aria-hidden={media.ariaHidden}
      className={storyStyles}
      />
  ))}
     </div>
  );
};

MediaModule.propTypes = {
  data: PropTypes.shape({
    logicalName: PropTypes.string.isRequired,
    media: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        altText: PropTypes.string,
        ariaHidden: PropTypes.bool,
      })
    ),
  }),
  stories: PropTypes.oneOf(['desktop','mobile']),
};
export default MediaModule;